module.exports = __webpack_public_path__ + "static/media/untrashTableRow.36fa0a06.svg";